import { Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { Context } from "./Context/Context";

function App() {
  return (
    <Context>
      <BrowserRouter basename={__BASE_PATH__}>
        <Suspense fallback={null}>
          <AppRoutes />
        </Suspense>
      </BrowserRouter>
    </Context>
  );
}

export default App;
